// he_gang_shu_lian

import { buildOnline } from "@/utils/global"

export const Szzaz = {
    CompanyId: 6,    
}

export function isSzzaz(id: number) {
    if (!buildOnline) {
        return false
    }
    return id === Szzaz.CompanyId
}